import { Pipe, PipeTransform } from '@angular/core';
export class LimitArrayPipe implements PipeTransform {
/**
 * @param {?} items
 * @param {?} value
 * @return {?}
 */
transform(items: any[], value: number) {
    if (!items) return [];

    if (!value) return [];

    const /** @type {?} */ ret = ( /** @type {?} */((<any>Object))).assign([], items);

    return ret.splice(0, value);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{
  name: 'tnkLimitArray',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LimitArrayPipe_tsickle_Closure_declarations() {
/** @type {?} */
LimitArrayPipe.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LimitArrayPipe.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
